import { ContactPortal } from "@/components/site/ContactPortal";

export default function Contact() {
  return <ContactPortal />;
}
